import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import ResultTable from "../../components/ResultTable";
import ModalInputCapital from "../../components/ModalInputCapital";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const FORMULAS = [
  "CÔNG THỨC NEW UPDATE",
  "CÔNG THỨC LOGARIT",
  "CÔNG THỨC LÃI ĐƠN",
  "CÔNG THỨC LÃI KÉP",
  "CÔNG THỨC VÔ CỰC",
  "CÔNG THỨC VECTOR",
  "CÔNG THỨC CHẴN LẺ",
  "CÔNG THỨC LŨY THỪA",
  "CÔNG THỨC LOẠI TRỪ",
];

export default function BaccaratRoomList() {
  const TELEGRAM_ADMIN_URL = "https://t.me/haclamcongthucbcr";
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [dataRoom, setDataRom] = useState<any>([]);
  const Cookies = require("js-cookie");
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);
  const [selectedFormula, setSelectedFormula] = useState<string | null>(FORMULAS[0]);
  const [displayRooms, setDisplayRooms] = useState<any[]>([]);
  const [roomDetails, setRoomDetails] = useState<any[]>([]);
  const [isCapitalModalOpen, setIsCapitalModalOpen] = useState(false);
  const [pendingRoom, setPendingRoom] = useState<any | null>(null);

  const token = Cookies.get("access_token");
  const user_infor = localStorage.getItem("user_info");

  useEffect(() => {
    if (user_infor) {
      const test = JSON.parse(user_infor);
      setCoins(test.coins);
    }
  }, [user_infor]);

  const isShowText = (value: any) => {
    if (value.maintenance === 1) {
      return "Đang bảo trì";
    }
    if (value.percentCurrent.Forecast) {
      return Math.round(value.percentCurrent.Forecast) + "%";
    }
    if (value.shuffle !== 0) {
      return "Đang xáo bài";
    }
  };

  const handleClick = (value: any) => {
    if (coins === 0) {
      Swal.fire({
        icon: "error",
        title: "Lỗi tải dữ liệu",
        html: `Bạn không đủ xu, vui lòng liên hệ admin <a href="${TELEGRAM_ADMIN_URL}" target="_blank" rel="noopener noreferrer" style="color:#00ff9d;text-decoration:underline;">@haclamcongthucbcr</a> qua telegram để nạp xu`,
        customClass: {
          popup: "bg-custom-image text-white",
          confirmButton: "swal-ok-white-border",
        },
      });
      return;
    }
    navigate(`/casino/room/${value.tableName}`);
  };

  const openCapitalModal = (value: any) => {
    if (coins === 0) {
      Swal.fire({
        icon: "error",
        title: "Lỗi tải dữ liệu",
        html: `Bạn không đủ xu, vui lòng liên hệ admin <a href="${TELEGRAM_ADMIN_URL}" target="_blank" rel="noopener noreferrer" style="color:#00ff9d;text-decoration:underline;">@haclamcongthucbcr</a>.`,
        customClass: {
          popup: "bg-custom-image text-white",
          confirmButton: "swal-ok-white-border",
        },
      });
      return;
    }
    setPendingRoom(value);
    setIsCapitalModalOpen(true);
  };

  // Fetch full room data (totalRound, groupRoad, percentCurrent) for the 4 displayed rooms
  useEffect(() => {
    if (!displayRooms?.length || displayRooms.length === 0) {
      setRoomDetails([]);
      return;
    }
    const promises = displayRooms.map((r: any) =>
      axios.get(
        `${process.env.REACT_APP_URL_API_CASINO}/predict/get-table-by-name?tableName=${r.tableName}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );
    Promise.all(promises)
      .then((res) => setRoomDetails(res.map((r) => r.data)))
      .catch(() => setRoomDetails([]));
  }, [displayRooms, token]);

  const RoomCard = ({ value, detail, index }: { value: any; detail: any; index: number }) => {
    const winRate =
      detail?.percentCurrent?.Forecast ?? value?.percentCurrent?.Forecast ?? null;
    return (
      <div
        className="lobby-room-card cursor-pointer rounded-xl overflow-hidden shadow-lg hover:opacity-95 transition-opacity w-full"
        onClick={() => handleClick(value)}
      >
        <div className="relative w-full">
          <img
            src="/assets/table-game.png"
            alt={`Bàn ${value?.tableName}`}
            className="block w-full h-auto object-contain"
          />
          <div className="lobby-room-overlay absolute inset-0 flex flex-col">
            <div className="lobby-room-title">
              Bàn {value?.tableName ?? index + 1}
            </div>
            <div className="lobby-room-result-area flex-1 min-h-0 w-[77%] ml-[-5px] flex justify-start items-stretch">
              <ResultTable tableData={detail?.totalRound} compact fill noBorder />
            </div>
            <div className="lobby-room-rate-wrap">
              <div
                style={{
                  fontFamily:
                    "Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                  color: "#F2A24A",
                  fontWeight: 500,
                  textShadow: "0 2px 6px rgba(0,0,0,0.45)",
                }}
              >
                <div className="lobby-room-rate-label" style={{ letterSpacing: 1 }}>
                  TỈ LỆ THẮNG
                </div>
                <div className="lobby-room-rate-value">
                  {winRate == null ? "--" : `${Math.round(winRate)}%`}
                </div>
              </div>
            </div>

            <button
              type="button"
              className="lobby-room-start-btn cursor-pointer hover:brightness-110 active:brightness-95"
              style={{
                position: "absolute",
                backgroundColor: "#F4B000",
                color: "#0b1520",
                fontWeight: 800,
                lineHeight: "100%",
                boxShadow: "0 4px 10px rgba(0,0,0,0.35)",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                openCapitalModal(value);
              }}
            >
              Bắt đầu
            </button>
          </div>
        </div>
      </div>
    );
  };

  const [isLoading, setIsLoading] = useState(false);

  const pickRandomRooms = (rooms: any[], count: number) => {
    if (!rooms || rooms.length === 0) return [];
    const shuffled = [...rooms].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, Math.min(count, shuffled.length));
  };

  useEffect(() => {
    if (dataRoom.length === 0) {
      setIsLoading(true);
      Swal.fire({
        title: "Đang tải dữ liệu trò chơi",
        html: "<p class='swal-loading-subtext'>Load Data.</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
        customClass: {
          popup: "swal-loading-modal",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      const timeout = setTimeout(() => {
        axios
          .get(
            `${process.env.REACT_APP_URL_API_CASINO}/predict/get-all-table`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((data) => setDataRom(data.data))
          .catch((err) => console.log(err));
      }, 1000); // Delay 1 giây

      return () => clearTimeout(timeout);
    } else {
      setIsLoading(false);
      Swal.close();
      setDisplayRooms((prev) =>
        prev && prev.length > 0 ? prev : pickRandomRooms(dataRoom, 4)
      );
    }

    // Clear timeout nếu component bị unmount hoặc dependencies thay đổi
  }, [dataRoom]);

  return (
    <>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <ModalInputCapital
        isOpen={isCapitalModalOpen}
        onClose={() => setIsCapitalModalOpen(false)}
        onConfirm={(value) => {
          const capital = Number.isNaN(value) ? 0 : value;
          const bet = Math.floor(capital / 10);
          localStorage.setItem("session_capital", String(capital));
          localStorage.setItem("session_bet_amount", String(bet));
          localStorage.setItem("session_current_capital", String(capital));
          setIsCapitalModalOpen(false);
          if (pendingRoom) {
            navigate(`/casino/room/${pendingRoom.tableName}`);
          }
        }}
      />
      <div
        className="lobby-scale-root min-h-screen bg-cover bg-center container-fluid lobby-bg position-relative mx-auto mb-5 max-w-screen-full"
      >
        <div className="container mx-auto py-4 md:py-10 px-2 md:px-0">
          {!isLoading && (
            <div className="flex flex-col md:flex-row gap-6">
              {/* Left sidebar: formulas */}
              <div className="w-full md:w-auto md:flex-shrink-0 flex justify-center md:justify-start">
                <div
                  className="lobby-formula-panel p-2 md:p-3 shadow-[0_0_18px_rgba(0,255,111,0.45)] w-full md:w-[319px] min-h-0 md:min-h-[520px]"
                >
                  <div className="formula-scroll lobby-formula-list h-[64px] grid grid-flow-col auto-cols-[calc(50%-4px)] gap-2 overflow-x-auto overflow-y-hidden items-center pb-0 md:h-auto md:flex md:flex-col md:h-full md:overflow-visible">
                    {FORMULAS.map((formula, index) => {
                      const isActive = selectedFormula === formula;
                      const isTitle = index === 0;
                      return (
                        <button
                          key={formula}
                          type="button"
                          onClick={() => {
                            setSelectedFormula(formula);
                            setDisplayRooms(pickRandomRooms(dataRoom, 4));
                          }}
                          className={`lobby-formula-btn w-full px-3 py-2 rounded-md font-semibold transition-all flex items-center justify-center text-center flex-shrink-0 h-[58px] md:h-auto md:flex-1 ${
                            isTitle
                              ? "text-[#FFD94A] shadow-[0_0_12px_rgba(0,255,153,0.9)]"
                              : "text-white hover:brightness-110"
                          }`}
                          style={{
                            fontFamily: "Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                            fontWeight: 700,
                            lineHeight: "100%",
                            ...(isTitle || isActive
                              ? {
                                  backgroundImage:
                                    "linear-gradient(180deg, #00FF9D 0%, #004C31 100%)",
                                }
                              : {
                                  backgroundColor: "#005625",
                                }),
                          }}
                        >
                          {formula}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Right content: tables */}
              <div
                className="lobby-right-panel w-full md:flex-1"
              >
                <div
                  className="flex items-center gap-2 cursor-pointer mb-3"
                  onClick={() => navigate("/")}
                >
                  <img
                    src="/assets/arrow-back.png"
                    alt="Back"
                    style={{ width: 24, height: 24 }}
                  />
                  <span
                    style={{
                      fontFamily:
                        "Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      fontWeight: 800,
                      fontSize: "15px",
                      lineHeight: "100%",
                      letterSpacing: 0,
                      color: "#FFFFFF",
                    }}
                  >
                    BACK
                  </span>
                </div>

                {displayRooms.length === 0 ? (
                  <p className="text-center text-white opacity-70">
                    Không có bàn nào để hiển thị.
                  </p>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 p-1 md:p-2 w-full items-start max-w-[760px] md:max-w-none mx-auto">
                    {displayRooms.map((e: any, idx: number) => (
                      <RoomCard key={e.id ?? e.tableName ?? idx} value={e} detail={roomDetails[idx]} index={idx} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <ModalConfirmLogout
          isShowLogout={isShowLogout}
          setIsShowLogout={() => {
            setIsShowLogout(false);
          }}
        />
        <style>{`
          .swal-ok-white-border {
            border: 2px solid #ffffff !important;
            border-radius: 999px !important;
            padding: 10px 26px !important;
            box-shadow: none !important;
          }
          .swal-ok-white-border:focus {
            box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35) !important;
          }

          .lobby-scale-root {
            --lobby-scale: 1;
          }
          @media (max-width: 768px) {
            .lobby-scale-root {
              --lobby-scale: 0.58;
            }
          }

          .lobby-formula-panel {
            border-radius: 20px;
            border: 3px solid #00ff6f;
            background-color: rgba(0, 41, 29, 0.85);
          }
          .lobby-formula-list .lobby-formula-btn {
            height: calc(100px * var(--lobby-scale));
            min-height: calc(100px * var(--lobby-scale));
            font-size: calc(26px * var(--lobby-scale));
          }
          .lobby-right-panel {
            width: 100%;
            min-height: calc(682px * var(--lobby-scale));
            border-radius: 20px;
            border: 3px solid #00ff6f;
            background-color: rgba(0, 41, 29, 0.85);
            padding: calc(10px * var(--lobby-scale)) calc(16px * var(--lobby-scale)) calc(16px * var(--lobby-scale)) calc(10px * var(--lobby-scale));
            box-sizing: border-box;
          }
          .lobby-room-card {
            max-width: calc(671px * var(--lobby-scale));
            margin: 0 auto;
            padding: calc(8px * var(--lobby-scale));
            --result-icon-size: calc(26px * var(--lobby-scale));
          }
          .lobby-room-overlay {
            padding: calc(8px * var(--lobby-scale));
          }
          .lobby-room-title {
            position: absolute;
            top: calc(10px * var(--lobby-scale));
            left: calc(10px * var(--lobby-scale));
            color: #ffffff;
            font-size: calc(20px * var(--lobby-scale));
            font-weight: 700;
            line-height: 100%;
            text-shadow: 0 2px 6px rgba(0, 0, 0, 0.65);
          }
          .lobby-room-result-area {
            padding-top: calc(36px * var(--lobby-scale));
            padding-bottom: calc(32px * var(--lobby-scale));
          }
          .lobby-room-rate-wrap {
            position: absolute;
            inset: 0 calc(10px * var(--lobby-scale)) 0 auto;
            width: 23%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            pointer-events: none;
          }
          .lobby-room-rate-label {
            font-size: calc(14px * var(--lobby-scale));
          }
          .lobby-room-rate-value {
            font-size: calc(30px * var(--lobby-scale));
            margin-top: calc(8px * var(--lobby-scale));
            line-height: 100%;
          }
          .lobby-room-start-btn {
            right: 0;
            bottom: 0;
            padding: calc(11px * var(--lobby-scale)) calc(18px * var(--lobby-scale));
            font-size: calc(14px * var(--lobby-scale));
          }

          .formula-scroll {
            scrollbar-width: thin;
            scrollbar-color: rgba(0, 255, 145, 0.65) transparent;
          }
          .formula-scroll::-webkit-scrollbar {
            height: 3px;
          }
          .formula-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .formula-scroll::-webkit-scrollbar-thumb {
            background: rgba(0, 255, 145, 0.65);
            border-radius: 999px;
          }
          @media (min-width: 769px) {
            .lobby-formula-list {
              height: 100%;
            }
            .lobby-formula-list .lobby-formula-btn {
              height: auto;
              min-height: unset;
            }
          }
        `}</style>
      </div>
    </>
  );
}
